// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Eq.eqArray(Data_Eq.eqString));
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var MenuIsSymbol = {
    reflectSymbol: function () {
        return "Menu";
    }
};
var CartIsSymbol = {
    reflectSymbol: function () {
        return "Cart";
    }
};
var CheckoutIsSymbol = {
    reflectSymbol: function () {
        return "Checkout";
    }
};
var productIdsIsSymbol = {
    reflectSymbol: function () {
        return "productIds";
    }
};
var ProductCardIsSymbol = {
    reflectSymbol: function () {
        return "ProductCard";
    }
};
var genericDecodeSumConstruct1 = /* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume);
var Menu = /* #__PURE__ */ (function () {
    function Menu() {

    };
    Menu.value = new Menu();
    return Menu;
})();
var Cart = /* #__PURE__ */ (function () {
    function Cart() {

    };
    Cart.value = new Cart();
    return Cart;
})();
var Checkout = /* #__PURE__ */ (function () {
    function Checkout() {

    };
    Checkout.value = new Checkout();
    return Checkout;
})();
var ProductCard = /* #__PURE__ */ (function () {
    function ProductCard(value0) {
        this.value0 = value0;
    };
    ProductCard.create = function (value0) {
        return new ProductCard(value0);
    };
    return ProductCard;
})();
var toFillFormTypePage = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var eqPage = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Menu && y instanceof Menu) {
                return true;
            };
            if (x instanceof Cart && y instanceof Cart) {
                return true;
            };
            if (x instanceof Checkout && y instanceof Checkout) {
                return true;
            };
            if (x instanceof ProductCard && y instanceof ProductCard) {
                return eq(x.value0.productIds)(y.value0.productIds);
            };
            return false;
        };
    }
};
var genericPage = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Menu.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return Cart.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return Checkout.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return new ProductCard(x.value0.value0.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Analytics.Types.Page (line 14, column 1 - line 14, column 63): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Menu) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Cart) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof Checkout) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof ProductCard) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)));
        };
        throw new Error("Failed pattern match at Restaumatic.Analytics.Types.Page (line 14, column 1 - line 14, column 63): " + [ x.constructor.name ]);
    }
};
var showPage = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPage)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(MenuIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(CartIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(CheckoutIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(productIdsIsSymbol)(/* #__PURE__ */ Data_Show.showArray(Data_Show.showString)))))(ProductCardIsSymbol)))))
};
var unscrambleDecodePage = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericPage)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(MenuIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(CartIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(CheckoutIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(ProductCardIsSymbol)(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons(productIdsIsSymbol)(/* #__PURE__ */ Unscramble.decodeArray1(Unscramble.decodeString1))(Unscramble.decodeRecordNil))))))))(Unscramble_Generic.defaultOptions)
};
var encodePage = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericPage)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(MenuIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(CartIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(CheckoutIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ProductCardIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)(productIdsIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.stringEncode))))))))))
};
var decodePage = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericPage)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(MenuIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(CartIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(CheckoutIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ProductCardIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)(productIdsIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Foreign_Generic_Class.stringDecode)))())))(Foreign_Generic_Class.genericCountArgsArgument)))))
};
export {
    Menu,
    Cart,
    Checkout,
    ProductCard,
    genericPage,
    eqPage,
    showPage,
    encodePage,
    decodePage,
    unscrambleDecodePage,
    toFillFormTypePage
};
